


















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class DetectModerationCard extends Vue {

    @Prop(Object) item!:any;

    private seen : boolean = false;

    created() {
        if (this.item.tags.length > 0) {
            this.item.tags.forEach((v : any) => {
                if (v.Name === 'Explicit Nudity') {
                    this.seen = true;
                }
            })
        }
        else {
            this.seen = false
        }
    }
    private get isBlind() {
        if (this.item.tags.length > 0) {
            return this.item.tags.map((v : any) => v.Name === 'Explicit Nudity')[0]
        }
        else return false
    }

    showMe() : void {
        this.seen = false
    }

    imgSrc(str : string) : string {
        return `https://rekonition-img.s3.amazonaws.com/${str}`
    }

}
